import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "X-Session-ID": sessionId },
        });
        if (!res.ok) throw new Error("auth failed");
        setUser(await res.json());
        window.history.replaceState({}, "", "/dashboard");
        window.location.replace("/dashboard");
      } catch {
        window.location.replace("/");
      }
    })();
  }, [location.hash, setUser]);

  return <div className="min-h-screen bg-white" data-testid="auth-callback" />;
}
